import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CheckCircle = createReactComponent("CheckCircle", ["svg", defaultAttributes, [["path", {
  d: "M22 11.08V12a10 10 0 11-5.93-9.14",
  key: "110yx7"
}], ["polyline", {
  points: "22 4 12 14.01 9 11.01",
  key: "ny83mg"
}]]]);
export default CheckCircle;